import React, {useEffect} from 'react'
import {Helmet} from "react-helmet";
import ImgKeeper from '../images/step-two-keeper.jpg'
import ImgForkLift from '../images/step-two-forklift.jpg'
import ImgFrames from '../images/step-two-frames.jpg'
import ImgExtractor from '../images/step-two-extractor.jpg'
import ImgStrain from '../images/step-two-strain.jpg'
import ImgStorage from '../images/step-two-barrels.jpg'
import ImgUpArrow from '../images/up-arrow.png'
import ImgOne from '../images/number-one.png'


const StepTwo = ({multipleLoc, packData}) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return (
        <div className="step step-two step-wrapper">
        <Helmet>
            <meta charSet="utf-8" />
            <title>Harvest Locations || Busy Bee Honey</title>
        </Helmet>
            <div className="contain">

                <section>
                    <h2>This honey was harvested in:</h2>
                    {multipleLoc &&
                        <p className="span-block">
                            {packData.harvestLocations.map((loc, i) => {
                                return(
                                    <span key={i}><strong>{loc}</strong></span>
                                )
                            })}    
                        </p>  
                    } 
                    {!multipleLoc && 
                        <p className="span-block"><span><strong>{packData.harvestLocation}</strong></span></p>
                    }
                    <div className="img-wrapper">
                        <img src={ImgKeeper} alt ="illustration of beekeeper handling hive" />
                    </div>
                    <p>Harvesting the honey — also known as extraction — involves removing the honey from the honeycomb.</p>
                </section>

                <section>
                    <h2>How extraction works:</h2>
                    <div className="img-wrapper">
                        <img src={ImgForkLift} alt="forklift moving bee hive" />
                    </div>
                    <div className="up-icon"><img src={ImgUpArrow} alt="" /></div>
                    <p>The hive boxes where the honey is stored, known as supers, are transported from the bee yard to the extraction facility. These hive boxes typically include 10 wooden frames that bees use to draw comb, and to store honey and pollen.</p>
                    <div className="img-wrapper">
                        <img src={ImgFrames} alt="frames being loaded into uncapping machine" />
                    </div>
                    <div className="up-icon"><img src={ImgUpArrow} alt="" /></div>
                    <p>Honey-filled frames are removed from the supers and placed into an uncapping machine designed to remove the bees' wax seal.</p>
                    <div className="img-wrapper">
                        <img src={ImgExtractor} alt="Honey extractor spinning" />
                    </div>
                    <div className="up-icon"><img src={ImgUpArrow} alt="" /></div>
                    <p>A honey extractor spins the frames at a high speed, forcing out the honey.</p>
                    <div className="img-wrapper">
                        <img src={ImgStrain} alt="Honey being strained" />
                    </div>
                    <div className="up-icon"><img src={ImgUpArrow} alt="" /></div>
                    <p>The honey is minimally strained to remove any foreign matter.</p>
                    <div className="img-wrapper">
                        <img src={ImgStorage} alt="Honey stored in drums" />
                    </div>
                    <div className="up-icon"><img src={ImgUpArrow} alt="" /></div>
                    <p>The honey is placed in drums, sealed, assigned a lot code, and readied to ship to the packaging facility.</p>


                </section>
           
                
            </div>
            <section className="cream-bkg number-ones">
                <div className="contain">
                    <div className="step-icon">
                        <img src={ImgOne} alt="" />
                    </div>
                    <p><em>Busy Bee Raw Honey is packed by Barkman Honey, the first company to develop an extraction facility survey tool that helps honey producers grade their facilities and ensure honey quality.
                    </em></p>
                </div>
            </section>
        </div>
    )
}

export default StepTwo
